export function OutlineLatitudeIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12.0001 21C14.6086 21 16.7233 16.9706 16.7233 12C16.7233 7.02944 14.6086 3 12.0001 3C9.3915 3 7.27686 7.02944 7.27686 12C7.27686 16.9706 9.3915 21 12.0001 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path d="M12 3V20.9568" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
    </svg>
  );
}
